import React, { useEffect } from 'react';
import { Modal, Input } from 'antd';
import {
  useCreateNakshatram,
  useUpdateNakshatram,
} from '../../services/nakshatram/nakshatram.service.hook';
import TmsRowVertical from '../../components/tms-customs/tms-row-vertical';

const TmsNakshatramCreateModal = ({ isOpen, onClose, editData }) => {
  const { mutate: createNakshatram, isPending: createLoading } =
    useCreateNakshatram();
  const { mutate: updateNakshatram, isPending: updateLoading } =
    useUpdateNakshatram();

  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');

  useEffect(() => {
    if (editData) {
      setName(editData.name);
      setDescription(editData.description);
    }
  }, [editData]);

  useEffect(() => {
    if (!isOpen) {
      setName('');
      setDescription('');
    }
  }, [isOpen]);

  const handleCreateNakshatram = () => {
    if (!name || !description) {
      return;
    }
    if (editData) {
      updateNakshatram(
        { nakshatramId: editData.id, name, description },
        {
          onSuccess: () => {
            onClose();
          },
        }
      );
    } else {
      createNakshatram(
        {
          name: name,
          description: description,
        },
        {
          onSuccess: () => {
            onClose();
          },
        }
      );
    }
  };

  return (
    <Modal
      destroyOnClose={true}
      title={
        editData ? `Edit Nakshatram Details - ${editData?.name}` : 'Create Nakshatram'
      }
      open={isOpen}
      onOk={handleCreateNakshatram}
      onCancel={() => {
        onClose();
      }}
      okButtonProps={{ loading: createLoading || updateLoading }}
    >
      <TmsRowVertical
        data={{
          one: 'Name',
          two: (
            <Input
              maxLength={220}
              placeholder='Name'
              style={{ width: '250px' }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCreateNakshatram();
                }
              }}
            />
          ),
          justify: 'center',
          style: { width: '100%', padding: '10px 0px' },
        }}
      />
      <TmsRowVertical
        data={{
          one: 'Description',
          two: (
            <Input
              maxLength={220}
              placeholder='Description'
              style={{ width: '250px' }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCreateNakshatram();
                }
              }}
            />
          ),
          justify: 'center',
          style: { width: '100%', padding: '10px 0px' },
        }}
      />
    </Modal>
  );
};

export default TmsNakshatramCreateModal;
